const Commission = () =>
    import("@/views/commission/Commission.vue");

export default {
    path: "commission",
        meta: { label: "Commission" },
        component: {
            render(c) {
              return c("router-view");
            },
        },
        children: [
            {
                path: "",
                meta: {
                requiresAuth: true,
                },
                component: Commission,
            },
        ],
};